/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Freebsd_1Inputs */

const en_pc_dl_freebsd_1 = /** @type {(inputs: Pc_Dl_Freebsd_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the x86_64 tarball.`)
};

const zh_pc_dl_freebsd_1 = /** @type {(inputs: Pc_Dl_Freebsd_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 x86_64 压缩包。`)
};

/**
* | output |
* | --- |
* | "Download the x86_64 tarball." |
*
* @param {Pc_Dl_Freebsd_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_freebsd_1 = /** @type {((inputs?: Pc_Dl_Freebsd_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Freebsd_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_freebsd_1(inputs)
	return zh_pc_dl_freebsd_1(inputs)
});
export { pc_dl_freebsd_1 as "pc.dl.freebsd.1" }